/**
 * UI Helper Functions
 */

/**
 * Show toast notification
 */
export function showToast(message: string, isError: boolean = false): void {
  const toast = document.getElementById('toast');
  if (!toast) return;

  toast.textContent = message;
  toast.classList.toggle('error', isError);
  toast.classList.add('show');

  setTimeout(() => {
    toast.classList.remove('show');
  }, 3000);
}

/**
 * Show loading spinner
 */
export function showLoading(elementId: string): void {
  const element = document.getElementById(elementId);
  if (element) {
    element.classList.add('show');
  }
}

/**
 * Hide loading spinner
 */
export function hideLoading(elementId: string): void {
  const element = document.getElementById(elementId);
  if (element) {
    element.classList.remove('show');
  }
}

/**
 * Copy text to clipboard
 */
export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    showToast('Tekst kopiert!');
  } catch (error) {
    showToast('Kunne ikke kopiere tekst', true);
  }
}

/**
 * Format date in Norwegian format
 */
export function formatDate(date: Date = new Date()): string {
  return date.toLocaleDateString('no-NO');
}

/**
 * Format time in Norwegian format
 */
export function formatTime(date: Date = new Date()): string {
  return date.toLocaleTimeString('no-NO', { hour: '2-digit', minute: '2-digit' });
}

/**
 * Switch tab
 */
export function switchTab(tabName: string): void {
  document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
  document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));

  const tabContent = document.getElementById(tabName);
  const tabButton = document.querySelector(`.tab[data-tab="${tabName}"]`);

  if (tabContent) tabContent.classList.add('active');
  if (tabButton) tabButton.classList.add('active');
}

/**
 * Show modal
 */
export function showModal(modalId: string): void {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.add('show');
  }
}

/**
 * Hide modal
 */
export function hideModal(modalId: string): void {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.remove('show');
  }
}

/**
 * Escape HTML to prevent XSS
 */
export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Get element by ID with type checking
 */
export function getElement<T extends HTMLElement>(id: string): T {
  const element = document.getElementById(id);
  if (!element) {
    throw new Error(`Element with id "${id}" not found`);
  }
  return element as T;
}

/**
 * Get input value safely
 */
export function getInputValue(id: string): string {
  const element = document.getElementById(id) as HTMLInputElement | HTMLTextAreaElement;
  return element?.value?.trim() || '';
}

/**
 * Set input value safely
 */
export function setInputValue(id: string, value: string): void {
  const element = document.getElementById(id) as HTMLInputElement | HTMLTextAreaElement;
  if (element) {
    element.value = value;
  }
}
